import { render, staticRenderFns } from "./SMSHistory.vue?vue&type=template&id=47f81f80"
import script from "./SMSHistory.vue?vue&type=script&lang=js"
export * from "./SMSHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports